import { AlertsQueueItem, ApiResponse } from 'app/shared/models';
import { catchError, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { SnackbarType } from '@fuse/services/snackbar';
import { translate } from '@jsverse/transloco';

import { BaseService } from '../base';

@Injectable({ providedIn: 'root' })
export class AlertsQueueService extends BaseService {
  private readonly _endPoint = '/v4/alerts-queue';

  constructor() {
    super();
  }

  getAlertsQueue(
    locationId?: string | null,
    partnerId?: string | null
  ) {
    return this.clientService
      .get<ApiResponse<AlertsQueueItem[]>>(
        `${this._endPoint}/location/${locationId ?? 'undefined'}`,
        partnerId ? { partnerId } : {}
      )
      .pipe(
        catchError(() => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.get_all_error')
          );

          return of({ data: [] } as ApiResponse<AlertsQueueItem[]>);
        })
      );
  }

  deleteAlertsQueueItem(itemId: string) {
    return this.clientService
      .delete<ApiResponse<null>>(`${this._endPoint}/${itemId}`)
      .pipe(
        catchError(({ success, error }) => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.delete_error')
          );

          return of(new ApiResponse<null>(success, null, error));
        })
      );
  }

  deleteDashboardAlerts(locationId?: string | null) {
    return this.clientService
      .delete<
        ApiResponse<{ alerts: number; issues: number; total: number }>
      >(
        `${this._endPoint}/dashboard/location/${
          locationId ?? 'undefined'
        }`
      )
      .pipe(
        catchError(({ success, error }) => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.delete_error')
          );

          return of(
            new ApiResponse<{
              alerts: number;
              issues: number;
              total: number;
            }>(success, null, error)
          );
        })
      );
  }
}
